import React from 'react'
import {useSelector, useDispatch} from 'react-redux'
import PartnerInformationForm from 'components/PartnerInfoForm'
import { updateAccountInfo } from 'store/actions/userActions'
import Nav from 'react-bootstrap/Nav'
import {Switch, Route, useRouteMatch, NavLink} from 'util/router'
import PartnerPaymentsForm from 'components/PartnerPaymentsForm'
import "./partnerInformation.scss";

function PartnerInformationPage(props) {

    const match = useRouteMatch()

    console.log("const the match: ", match)

    const dispatch = useDispatch()

    const isLoading = useSelector(state => state.user.loading)
    const isSaving = useSelector(state => state.user.saving)
    const user = useSelector(state => state.user.userData)
    const error = useSelector(state => state.user.error)
    const success = useSelector(state => state.user.success)

    const onSubmit = (data) => {
        console.log("PARTNER INFO SAVING: ", data)
        dispatch(updateAccountInfo(data))
    }

    const businessActive = match.isExact
    const paymentsActive = !match.isExact

    return (<>
    <div className="container pb-5 px-0">
        {!isLoading && user.platformID ? (
            <div>
                {success && (
                    <div className="alert alert-success" role="alert">
                        {success}
                    </div>
                )}
                {error && (
                    <div className="alert alert-danger" role="alert">
                        {error}
                    </div>
                )}
                <Nav variant="pills" className="nav nav-pills">
                    <Nav.Link className={businessActive ? "active" : ""}>
                        <NavLink to={`${match.url}`}>
                            <span style={{color:(businessActive ? "white" : "")}} >Business</span>
                        </NavLink>

                    </Nav.Link>
                    <Nav.Link className={paymentsActive ? "active" : ""}>
                        <NavLink to={`${match.url}/payments`}>
                            <span style={{color:(paymentsActive ? "white" : "")}} >Payments</span>
                        </NavLink>
                    </Nav.Link>

                </Nav>
                <Switch>
                    <Route path={`${match.url}/payments`}>
                        <PartnerPaymentsForm 
                        user={user}
                        handleFormSubmission={onSubmit}
                        isSaving={isSaving}
                        />

                    </Route>
                    <Route path={`${match.url}`}>

                        <PartnerInformationForm
                        user={user}
                        handleFormSubmission={onSubmit}
                        isSaving={isSaving}
                        />

                    </Route>
                </Switch>
            </div>
        ) : (
            <div>loading</div>
        )}

    </div>
    </>)
}

export default PartnerInformationPage;